import { reducerCreator } from 'redux-rest-helper-for-loopback';
import { clientFormInitValue } from '../../forms/ClientForm';
import ClientsAction from './ClientsAction';

export default reducerCreator(ClientsAction.ENTRY, clientFormInitValue).getReducer();
